import { usePortal } from './Portal.hooks';

import type { PortalProps } from './Portal.d';

const PortalBase = ({ children, htmlElementID = 'portal' }: PortalProps) => {
  const { Portal } = usePortal({ htmlElementID });

  return <Portal>{children}</Portal>;
};

export default PortalBase;
